import React, { Fragment } from 'react'

import Icon from '@scoir/components-core/dist/components/Icon'
import cn from 'classnames'
import notificationIcon from 'icons/notifications.svg'
import notificationIconLight from 'icons/notifications_light.svg'
import PropTypes from 'prop-types'

import './NotificationCountBadge.scss'

const NotificationCountBadge = ({ unreadInboxCount, theme }) => {
  return (
    <span className={cn('inbox-count-badge-comp', `${theme}-skin`)}>
      <Icon
        def={theme === 'light' ? notificationIconLight : notificationIcon}
        size="sm"
      />
      <span className="badge">{unreadInboxCount >= 0 ? unreadInboxCount : <Fragment>&ndash;</Fragment>}</span>
    </span>
  )
}

NotificationCountBadge.propTypes = {
  theme: PropTypes.oneOf(['dark', 'light']),
  unreadInboxCount: PropTypes.number,
}
NotificationCountBadge.defaultProps = {
  theme: 'dark',
}
export default NotificationCountBadge
